"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDate = void 0;
const defaultLocale = typeof navigator !== 'undefined' ? navigator.language : 'en-US';
function formatDate(date, options = {}) {
    if (date == null || date === '')
        return '';
    const d = typeof date === 'string' ? new Date(date) : date;
    if (Number.isNaN(d.getTime()))
        return '';
    const { dateOnly = true, locale = defaultLocale } = options;
    if (dateOnly) {
        return d.toLocaleDateString(locale, { month: 'short', day: 'numeric', year: 'numeric' });
    }
    return d.toLocaleString(locale, {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
    });
}
exports.formatDate = formatDate;
